import http from '../plugins/axios'

export const getAllSupplierList = async (params) => {
  try {
    const response = await http.get(`/api/v2/suppliers`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const addSupplier = async (payload) => {
  try {
    const response = await http.post(`/api/v2/suppliers`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateSupplier = async (supplierId, payload) => {
  try {
    const response = await http.put(`/api/v2/suppliers/${supplierId}`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteSupplier = async (supplierId) => {
  try {
    const response = await http.delete(`/api/v2/suppliers/${supplierId}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getSupplierDetail = async (supplierId, params) => {
  try {
    const response = await http.get(`/api/v2/supplier/${supplierId}`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}